export const pageContents = {
    public: 'public',
    owngroup: 'owngroup',
    mygroup: 'mygroup',
    favorite: 'favorite',
    popular: 'popular',
    pending: 'pending',
    buywithme: 'buywithme'
}